import helpers from '@/helpers';

export default {
	academicYearsDropdown: (state) => {
		if (!state.academicYears) return [];
		const items = state.academicYears.map((academicYear) => ({
			text: `${helpers.dateTime.getHumanDate(academicYear.startDate)} - ${helpers.dateTime.getHumanDate(academicYear.endDate)}`,
			value: academicYear.id
		}));
		return items;
	}
};



// WEBPACK FOOTER //
// ./src/store/persistent/getters.js